module.exports = __webpack_public_path__ + "img/nfccard.5bbd5530.svg";